import React from 'react';
import * as ThemeUI from 'theme-ui';

export const Box = ({ className, sx, as, children, ...props }) => (
  <ThemeUI.Box
    as={as}
    sx={sx}
    className={className}
    {...props}
  >
    {children}
  </ThemeUI.Box>
);
